"use client";
import {
  useSelectStore
} from "../__chunks/Y7TEGSHG.js";
import "../__chunks/3LH6HMTR.js";
import {
  SelectContextProvider
} from "../__chunks/SLHXTMPQ.js";
import "../__chunks/OIB4PV4M.js";
import "../__chunks/QZUWIJQN.js";
import "../__chunks/APGXEJ2Q.js";
import "../__chunks/G4PVPWEW.js";
import "../__chunks/COWZSPJ7.js";
import "../__chunks/CMXOY7UW.js";
import "../__chunks/JDEWEW7S.js";
import "../__chunks/7FZLUSKW.js";
import "../__chunks/CO7ZDQU2.js";
import "../__chunks/B5WJDZ55.js";
import "../__chunks/C76P7QQC.js";
import "../__chunks/CTKPPFRS.js";
import "../__chunks/HNHAUIIY.js";
import "../__chunks/SK3NAZA3.js";
import "../__chunks/3YLGPPWQ.js";

// src/select/select-provider.tsx
import { jsx } from "react/jsx-runtime";
function SelectProvider(props = {}) {
  const store = useSelectStore(props);
  return /* @__PURE__ */ jsx(SelectContextProvider, { value: store, children: props.children });
}
export {
  SelectProvider
};
